import React from 'react';
import styles from './DailyProverb.module.css';
import PaithaniPattern from '../PaithaniPattern/PaithaniPattern';
import { formatDate } from '../../utils/dateUtils';

interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

interface DailyProverbProps {
  proverb: Proverb;
}

const DailyProverb: React.FC<DailyProverbProps> = ({ proverb }) => {
  const today = formatDate();

  const scrollToCollection = () => {
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className={styles['daily-proverb-hero']}>
      <PaithaniPattern pattern="wave" opacity={0.08} color="var(--color-terracotta)" />

      <div className={styles['hero-content']}>
        <div className={styles['hero-text']}>
          <div className={styles['hero-label']}>
            <span className={styles['date']}>{today}</span>
            <span className={styles['divider']}>•</span>
            <span className={styles['title']}>Today's Proverb</span>
          </div>

          <div className={styles['proverb-display']}>
            <div className={styles['proverb-marathi']} lang="mr">
              {proverb.marathi}
            </div>

            <div className={styles['proverb-meaning']}>
              {proverb.idiomatic}
            </div>
          </div>

          <button
            className={styles['cta-button']}
            onClick={scrollToCollection}
            aria-label="Explore all proverbs"
          >
            Explore All Proverbs
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 4v12m0 0l-4-4m4 4l4-4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default DailyProverb;
